import { render, staticRenderFns } from "./ArticleCardThumbnail.vue?vue&type=template&id=f4b24b46"
import script from "./ArticleCardThumbnail.vue?vue&type=script&lang=js"
export * from "./ArticleCardThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ArticleCardThumbnail.vue?vue&type=style&index=0&id=f4b24b46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports